export const searchData =
[
  {
    "movieName": "Force",
    "imageUrl": "assets/Movies/Force.jpg"
  },
  {
    "movieName": "Bang Bang",
    "imageUrl": "assets/Movies/BangBang.jpg"
  },
  {
    "movieName": "Kick",
    "imageUrl": "assets/Movies/Kick.jpg"
  },
  {
    "movieName": "Runway",
    "imageUrl": "assets/Movies/Runway.jpg"
  },
  {
    "movieName": "Dost",
    "imageUrl": "assets/Movies/Dost.jpg"
  },
  {
    "movieName": "War",
    "imageUrl": "assets/Movies/War.jpg"
  },
  {
    "movieName": "Players",
    "imageUrl": "assets/Movies/Players.jpg"
  },
  {
    "movieName": "Don 2",
    "imageUrl": "assets/Movies/Don2.jpg"
  },
  {
    "movieName": "Fateh",
    "imageUrl": "assets/Movies/Fateh.jpg"
  },
  {
    "movieName": "Kisi Ka Bhai Kisi Ki Jaan",
    "imageUrl": "assets/Movies/KisiKaBhaiKisiKiJaan.jpg"
  },
  {
    "movieName": "Yodha",
    "imageUrl": "assets/Movies/Yodha.jpg"
  },
  {
    "movieName": "GanguBai Kathawadi",
    "imageUrl": "assets/Movies/GanguBaiKathawadi.jpg"
  },
  {
    "movieName": "Munna Michael",
    "imageUrl": "assets/Movies/MunnaMichael.jpg"
  },
  {
    "movieName": "Bhediya",
    "imageUrl": "assets/Movies/Bhediya.jpg"
  },
  {
    "movieName": "Mother India",
    "imageUrl": "assets/Movies/MotherIndia.jpg"
  },
  {
    "movieName": "Baazaar",
    "imageUrl": "assets/Movies/Baazaar.jpg"
  },
  {
    "movieName": "RRR",
    "imageUrl": "assets/Movies/RRR.jpg"
  },
  {
    "movieName": "The Rocky Horror Picture Show",
    "imageUrl": "assets/Movies/TheRockyHorrorPictureShow.jpg"
  },
  {
    "movieName": "The Quiet Girl",
    "imageUrl": "assets/Movies/theQuietGirl.jpg"
  },
  {
    "movieName": "The Picture of Dorian Gray",
    "imageUrl": "assets/Movies/ThePictureofDorianGray.jpg"
  },
  {
    "movieName": "Jurassic Park",
    "imageUrl": "assets/Movies/JurassicPark.jpg"
  },
  {
    "movieName": "House Of Gucci",
    "imageUrl": "assets/Movies/HouseOfGucci.jpg"
  },
  {
    "movieName": "The Wolf of Wall Street",
    "imageUrl": "assets/Movies/TheWolfofWallStreet.jpg"
  },
  {
    "movieName": "Titanic",
    "imageUrl": "assets/Movies/Titanic.jpg"
  },
  {
    "movieName": "Shutter Island",
    "imageUrl": "assets/Movies/ShutterIsland.jpg"
  },
  {
    "movieName": "Guardians of The Galaxy",
    "imageUrl": "assets/Movies/GuardiansofTheGalaxy.jpg"
  },
  {
    "movieName": "Empire Strikes Back",
    "imageUrl": "assets/Movies/EmpireStrikesBack.jpg"
  },
  {
    "movieName": "Dora & The Lost City Of Gold",
    "imageUrl": "assets/Movies/DoraandTheLostCityOfGold.jpg"
  },
  {
    "movieName": "Harry Potter",
    "imageUrl": "assets/Movies/HarryPotter.jpg"
  },
  {
    "movieName": "Jaws",
    "imageUrl": "assets/Movies/Jaws.jpg"
  },
  {
    "movieName": "Avengers Infinity War",
    "imageUrl": "assets/Movies/AvengersInfinityWar.jpg"
  },
  {
    "movieName": "John Wick",
    "imageUrl": "assets/Movies/JohnWick.jpg"
  },
  {
    "movieName": "Beauty & The Beast",
    "imageUrl": "assets/Movies/BeautyAndTheBeast.jpg"
  },
  {
    "movieName": "Replicas",
    "imageUrl": "assets/Movies/Replicas.jpg"
  },
  {
    "movieName": "Joker",
    "imageUrl": "assets/Movies/Joker.jpg"
  },
  {
    "movieName": "Casino",
    "imageUrl": "assets/Movies/Casino.jpg"
  },
  {
    "movieName": "SuperBad",
    "imageUrl": "assets/Movies/SuperBad.jpg"
  },
  {
    "movieName": "The Rocky Horror Picture Show",
    "imageUrl": "assets/Movies/TheRockyHorrorPictureShow.jpg"
  },
  {
    "movieName": "The Quiet Girl",
    "imageUrl": "assets/Movies/theQuietGirl.jpg"
  },
  {
    "movieName": "The Picture of Dorian Gray",
    "imageUrl": "assets/Movies/ThePictureofDorianGray.jpg"
  },
  {
    "movieName": "Jurassic Park",
    "imageUrl": "assets/Movies/JurassicPark.jpg"
  },
  {
    "movieName": "House Of Gucci",
    "imageUrl": "assets/Movies/HouseOfGucci.jpg"
  },
  {
    "movieName": "The Wolf of Wall Street",
    "imageUrl": "assets/Movies/TheWolfofWallStreet.jpg"
  },
  {
    "movieName": "Titanic",
    "imageUrl": "assets/Movies/Titanic.jpg"
  },
  {
    "movieName": "Shutter Island",
    "imageUrl": "assets/Movies/ShutterIsland.jpg"
  },
  {
    "movieName": "Guardians of The Galaxy",
    "imageUrl": "assets/Movies/GuardiansofTheGalaxy.jpg"
  },
  {
    "movieName": "Empire Strikes Back",
    "imageUrl": "assets/Movies/EmpireStrikesBack.jpg"
  },
  {
    "movieName": "Dora & The Lost City Of Gold",
    "imageUrl": "assets/Movies/DoraandTheLostCityOfGold.jpg"
  },
  {
    "movieName": "Harry Potter",
    "imageUrl": "assets/Movies/HarryPotter.jpg"
  },
  {
    "movieName": "Jaws",
    "imageUrl": "assets/Movies/Jaws.jpg"
  },
  {
    "movieName": "Avengers Infinity War",
    "imageUrl": "assets/Movies/AvengersInfinityWar.jpg"
  },
  {
    "movieName": "John Wick",
    "imageUrl": "assets/Movies/JohnWick.jpg"
  },
  {
    "movieName": "Beauty & The Beast",
    "imageUrl": "assets/Movies/BeautyAndTheBeast.jpg"
  },
  {
    "movieName": "Replicas",
    "imageUrl": "assets/Movies/Replicas.jpg"
  },
  {
    "movieName": "Joker",
    "imageUrl": "assets/Movies/Joker.jpg"
  },
  {
    "movieName": "Casino",
    "imageUrl": "assets/Movies/Casino.jpg"
  },
  {
    "movieName": "A Beautiful Mind",
    "imageUrl": "assets/Movies/ABeautifulMind.jpg"
  },
  {
    "movieName": "A War",
    "imageUrl": "assets/Movies/AWar.jpg"
  },
  {
    "movieName": "Baby Doll",
    "imageUrl": "assets/Movies/BabyDoll.jpg"
  },
  {
    "movieName": "Batman Begins",
    "imageUrl": "assets/Movies/BatmanBegins.jpg"
  },
  {
    "movieName": "ABCD",
    "imageUrl": "assets/Movies/ABCD.jpg"
  },
  {
    "movieName": "ABCD",
    "imageUrl": "assets/Movies/TheWiseGuys.jpg"
  }
]